module.exports = __webpack_public_path__ + "public-roadmap-2-5c4b05aa22d4bcd3236fffc882157310.webp";